var closeButtonInit = function (ele) {
    var closeButton = islington.
    checkValidity(ele)?ele:
    $('[data-button-close]');

    closeButton.off('click').
        on('click', function (e) {
            var specificContainer =
            islington.findNearestElement(this, '[data-close-container]', 2),
            _self = $(this),
            parentContainer = _self.parent(),
            closingContainer = islington.checkValidity(
            specificContainer) ? specificContainer : parentContainer,
            dataId = _self.data('button-close');
       
            closingContainer.hide();

            if (islington.
                checkValidityPlusStringEmptiness
                (dataId))
            {
                dataIdContainer = islington.dataIdElement(dataId);
                dataIdContainer.hide();
            }

        if (closingContainer.hasClass("open")
            || closingContainer.hasClass("is-open"))
        {
            var toggleButton = closingContainer.prev(".is-active, .active");
            toggleButton.removeClass('active is-active is-scrolled');
            closingContainer.removeClass('open is-open');
            closingContainer.attr({ 'aria-hidden': 'true' });
        }
        return false;
    });
};      

